import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'

import { Spinner } from '../../../Components'
import { useCQuery } from '../../../Services'
import { cap } from '../../../State'
import { translations } from '../../../translations'
import {
  Campi1a10Section,
  HotelSection,
  PlaneSection,
  TrainSection,
  TransferSection,
  TravellerMidOfficeSection
} from '../../Gigi/GigiForm/Sections'

const language = cap.language.state || 'IT'
const t = translations[language]

export const FormView = ({ stateIndex }) => {
  const { processId } = useParams()
  const { data: processSteps = [], isSuccess } = useCQuery(['processSteps', processId])

  const [initialState, setInitialState] = useState({})
  const [finalState, setFinalState] = useState({})

  useEffect(() => {
    setInitialState(processSteps[stateIndex]?.initialState || {})
    setFinalState(processSteps[stateIndex]?.finalState || {})
  }, [stateIndex, processSteps])

  if (!isSuccess) return <Spinner />

  const initalStateProps = [initialState, () => {}]
  const finalStateProps = [finalState, () => {}]

  return (
    <div className="process-compare-form-grid">
      <div>
        <div className="process-compare-col__title">
          <i className="pi pi-file" style={{ fontSize: 16 }} />
          {t.pfInitialState}
        </div>
        <TravellerMidOfficeSection state={initalStateProps} readOnly />
        <TransferSection state={initalStateProps} readOnly />
        <Campi1a10Section state={initalStateProps} readOnly />
        <PlaneSection state={initalStateProps} readOnly />
        <TrainSection state={initalStateProps} readOnly />
        <HotelSection state={initalStateProps} readOnly />
      </div>
      <div>
        <div className="process-compare-col__title">
          <i className="pi pi-file-edit" style={{ fontSize: 16 }} />
          {t.pfFinalState}
        </div>
        <TravellerMidOfficeSection state={finalStateProps} readOnly />
        <TransferSection state={finalStateProps} readOnly />
        <Campi1a10Section state={finalStateProps} readOnly />
        <PlaneSection state={finalStateProps} readOnly />
        <TrainSection state={finalStateProps} readOnly />
        <HotelSection state={finalStateProps} readOnly />
      </div>
    </div>
  )
}
